exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttons[data-v-45596963]{margin-top:16px;text-align:center}", ""]);

// exports
